import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthApiService } from '../../../../core/services/auth/auth-api.service';

@Component({
  selector: 'app-oauth-redirect',
  standalone: true,
  imports: [],
  templateUrl: './oauth-redirect.component.html',
  styleUrl: './oauth-redirect.component.scss',
})
export class OauthRedirectComponent implements OnInit {
  private _authService: AuthApiService = inject(AuthApiService);
  private _router: Router = inject(Router);
  private _route: ActivatedRoute = inject(ActivatedRoute);
  private _toast = inject(ToastrService);

  ngOnInit(): void {
    const params = this._route.snapshot.queryParams;
    this._handleQueryParams(params);
  }

  private _handleQueryParams(params: Record<string, string>): void {
    const token = params['token'];
    const error = params['error'];

    if (error) {
      this._handleError(error);
      return;
    }

    if (token) {
      this._handleToken(token);
    }
  }

  private _handleError(error: string): void {
    switch (error) {
      case 'email_exists':
        this._toast.error('Ce compte GitHub est déjà utilisé. Merci d’en choisir un autre.', 'Erreur');
        break;
      case 'email_missing':
        this._toast.error("L'email GitHub n'a pas pu être récupéré.", 'Erreur');
        break;
      default:
        this._toast.error('Une erreur inattendue est survenue lors de la connexion.', 'Erreur');
        break;
    }
    this._redirectToHome();
  }

  private _handleToken(token: string): void {
    localStorage.setItem('token', token);
    this._authService.getUser$().subscribe({
      next: () => {
        this._toast.success('Connexion réussie avec GitHub', 'Succès');
        this._redirectToHome();
      },
      error: err => {
        console.error('[OAuth] Failed to fetch user:', err);
        this._toast.error("Impossible de récupérer l'utilisateur.", 'Erreur');
        this._redirectToHome();
      },
    });
  }

  private _redirectToHome(): void {
    this._router.navigate(['']);
  }
}
